<div class="modal-content">
  <div *ngIf="!feedbackOK" class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ 'sharedModule.bkgRecoveryPassDialog.title' | translate }}
      </h3>
      <button (click)="onClickClose()" type="button" class="modal__close">
        <img src="assets/images/icons/close.svg" />
      </button>
    </div>

    <form *ngIf="form" [formGroup]="form" errorTailor>
      <div class="modal__body">
        <span>
          {{ 'sharedModule.bkgRecoveryPassDialog.body' | translate }}
        </span>
        <div class="modal__section form-compact">
          <div class="form-group" [class.success]="isValidField('email')">
            <label for="user-email" class="sr-only">{{
              'travelerStep.reservationForm.email' | translate
            }}</label>
            <input
              type="email"
              id="user-email"
              formControlName="email"
              placeholder="{{
                'travelerStep.reservationForm.email' | translate
              }}"
              [class.warning]="hasErrors('email')"
              controlErrorsClass="info-field"
            />
          </div>
        </div>
        <span *ngIf="errorText" class="color-error">
          {{ errorText }}
        </span>
      </div>
      <div class="modal__footer">
        <button
          (click)="onClickSendMail()"
          class="btn-primary btn-large is-block"
          [class.disabled]="isButtonDisabled"
        >
          {{ 'sharedModule.bkgRecoveryPassDialog.send' | translate }}
        </button>
      </div>
    </form>
  </div>
  <div *ngIf="feedbackOK" class="modal__content modal__blueBackground">
    <div class="modal__header">
      <img class="modal__img-centered" src="assets/images/icons/email-ok.svg" />
    </div>
    <div class="modal__body">
      <h4 class="h4 modal__body_title modal__blueBackground">
        {{ 'sharedModule.bkgRecoveryPassDialog.checkMail' | translate }}
      </h4>
      <span class="modal__blueBackground">
        {{
          'sharedModule.bkgRecoveryPassDialog.mailSended'
            | translate: { email: sendedEmail }
        }}
      </span>
      <button
        (click)="onClickClose()"
        type="button"
        id=""
        class="btn-primary btn-large is-block modal__blueButton"
      >
        {{ 'sharedModule.bkgRecoveryPassDialog.accept' | translate }}
      </button>
    </div>
  </div>
</div>
